import {
    GET_ORGANIZATIONS,
    POST_ORGANIZATION,
    PATCH_ORGANIZATION,
    DELETE_ORGANIZATION
  } from "resources/ApiUrls"
  import MyAxiosInstance from "utils/MyAxiosInstance"
  
  const getOrganizations = () => MyAxiosInstance.get(GET_ORGANIZATIONS());
  
  const create = (organizationObject) => MyAxiosInstance.post(POST_ORGANIZATION(), organizationObject)
  
  const update = (organizationId, organizationObject) => MyAxiosInstance.patch(PATCH_ORGANIZATION(organizationId), organizationObject)
  
  const remove = (organizationId) => MyAxiosInstance.delete(DELETE_ORGANIZATION(organizationId))
  
  const organizationAPICalls = { getOrganizations, create, update, remove }
  
  export default organizationAPICalls
  